module.exports = __webpack_public_path__ + "static/carFinanceImage-fc710ac99e43dfef57b1a320b12d2230.jpg";